export default __webpack_public_path__ + "static/media/submit.d42274f6.svg";